/**
 * Get First item from an array or return the passing instance
 * @param item
 */
export function getFirstChildOrSelf<T>(item: T| T[]): T {

  return Array.isArray(item) ? item[0] : item;

}
